<div class="usuario-select dropdown">
    <button class="btn btn-light dropdown-toggle" #dropdownToggle type="button" data-toggle="dropdown" aria-expanded="false" [disabled]="disabled">
        <ng-template [ngIf]="usuario">
            <sgt-avatar
              [settings]="{
                imageUrl: usuario.avatarUrl,
                fullName: usuario.nome,
                isShowLabelNameRight: true
              }">
            </sgt-avatar>
        </ng-template>

        <ng-template [ngIf]="!usuario">
            <sgt-avatar
              [settings]="{
                fullName: empityName,
                isShowLabelNameRight: true
              }">
            </sgt-avatar>
        </ng-template>
    </button>

    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <form class="form-filter" novalidate>
                <input type="text" class="form-control" [(ngModel)]="filter" name="usuarioSelectFilter" placeholder="Digite para pesquisar">
            </form>
            <div class="dropdown-menu-itens">
                <a class="dropdown-item"
                    [class.dropdown-item-select]="!idUsuario"
                    (click)="select(null)">
                    {{empityName}}
                </a>
                <a *ngFor="let user of usuarios | usuarioFilter: filter"
                    class="dropdown-item"
                    [class.dropdown-item-select]="user.id == idUsuario"
                    (click)="select(user)">
                    <sgt-avatar
                      [settings]="{
                        imageUrl: user.avatarUrl,
                        fullName: user.nome,
                        isShowLabelNameRight: true
                      }">
                    </sgt-avatar>
                </a>
            </div>
        </div>
    </div>
</div>
